<div class="max-w-4xl mx-auto p-8 min-h-screen">
    <p-toast></p-toast>
    <p-confirmDialog></p-confirmDialog>

    <!-- Custom Modal for Upcoming Interactions -->
    <app-custom-confirm-modal
        [isVisible]="showUpcomingInteractionsModal"
        [title]="'Upcoming Interactions Found'"
        i18n-title
        [message]="upcomingInteractionsMessage"
        [confirmLabel]="'Mark All Complete & Create Contract'"
        i18n-confirmLabel
        [cancelLabel]="'Cancel'"
        i18n-cancelLabel
        (confirm)="onConfirmUpcomingInteractions()"
        (cancel)="onCancelUpcomingInteractions()">
    </app-custom-confirm-modal>

    <div class="text-start mb-8">
        <h2 class="font-bold text-2xl mb-1" i18n>Schedule Interaction</h2>
        <p class="text-[#6B7280] text-sm m-0" i18n>Log, track, and manage all your customer interactions.</p>
    </div>

    <div class="space-y-6">
        <form [formGroup]="sheduleInteractionForm" class="space-y-8">
            <p-card styleClass="p-4">
                <div class="space-y-6">
                    <!-- Interaction Type -->
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div class="flex flex-col gap-2">
                            <label for="interactionType" class="font-medium text-gray-800 mb-1" i18n>
                                Interaction Type <span class="text-red-500">*</span>
                            </label>
                            <p-select id="interactionType" formControlName="interactionType"
                                [options]="interactionTypeOptions" optionLabel="label" optionValue="value"
                                placeholder="Select interaction type" i18n-placeholder
                                class="w-full rounded-lg border border-gray-300 text-base transition-all duration-200 focus:border-indigo-400 focus:ring-4 focus:ring-indigo-100 invalid:border-red-500 invalid:focus:ring-red-100">
                            </p-select>
                        </div>
                    </div>

                    <!-- Date and Time -->
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div class="flex flex-col gap-2">
                            <label for="interactionDate" class="font-medium text-gray-800 mb-1" i18n>
                                Interaction Date <span class="text-red-500">*</span>
                            </label>
                            <input id="interactionDate" type="date" pInputText formControlName="interactionDate"
                                placeholder="Enter interaction date" i18n-placeholder
                                class="w-full rounded-lg border border-gray-300 text-base transition-all duration-200 focus:border-indigo-400 focus:ring-4 focus:ring-indigo-100 invalid:border-red-500 invalid:focus:ring-red-100" />
                        </div>

                        <div class="flex flex-col gap-2">
                            <label for="interactionTime" class="font-medium text-gray-800 mb-1" i18n>
                                Interaction Time <span class="text-red-500">*</span>
                            </label>
                            <input id="interactionTime" type="time" pInputText formControlName="interactionTime"
                                placeholder="Enter interaction time" i18n-placeholder
                                class="w-full rounded-lg border border-gray-300 text-base transition-all duration-200 focus:border-indigo-400 focus:ring-4 focus:ring-indigo-100 invalid:border-red-500 invalid:focus:ring-red-100" />
                        </div>
                    </div>

                    <!-- Interaction Status -->
                    <div class="grid grid-cols-1 gap-6">
                        <div class="flex flex-col gap-2">
                            <label for="interactionStatus" class="font-medium text-gray-800 mb-1" i18n>
                                Interaction Status <span class="text-red-500">*</span>
                            </label>
                            <div class="card flex justify-start gap-4">
                                <div class="flex items-center">
                                    <p-radiobutton inputId="completed" formControlName="interactionStatus" value="completed" />
                                    <label for="completed" class="ml-2" i18n>Completed</label>
                                </div>
                                <div class="flex items-center">
                                    <p-radiobutton inputId="upcoming" formControlName="interactionStatus" value="upcoming" />
                                    <label for="upcoming" class="ml-2" i18n>Upcoming</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Conditional Fields for Completed Status -->
                    <div *ngIf="isCompletedStatus" class="space-y-6">
                        <!-- Interaction Notes -->
                        <div class="grid grid-cols-1 gap-6">
                            <div class="flex flex-col gap-2">
                                <label for="interactionNotes" class="font-medium text-gray-800 mb-1" i18n >
                                    Interaction Notes
                                </label>
                                <textarea id="interactionNotes" pInputText formControlName="interactionNotes"
                                    placeholder="Enter detailed notes about the interaction..." i18n-placeholder rows="4"
                                    class="w-full rounded-lg border border-gray-300 text-base transition-all duration-200 focus:border-indigo-400 focus:ring-4 focus:ring-indigo-100 invalid:border-red-500 invalid:focus:ring-red-100"></textarea>
                            </div>
                        </div>

                        <!-- Document Upload -->
                        <div class="mt-6">
                            <div class="flex items-center gap-3">
                                <p class="font-medium text-gray-800 mb-3" i18n>Upload Document</p>
                            </div>

                            <div class="grid grid-cols-1 gap-6">
                                <div class="flex flex-col gap-2">
                                    <!-- File Upload Progress -->
                                    <div *ngIf="isFileUploading" class="mb-4">
                                        <p-progressBar mode="indeterminate" styleClass="h-2"></p-progressBar>
                                        <small class="text-gray-500 text-sm mt-2 block" i18n>Uploading file...</small>
                                    </div>

                                    <!-- Uploaded File Display -->
                                    <div *ngIf="uploadedFileUrl && !isFileUploading"
                                        class="mb-4 p-4 bg-green-50 border border-green-200 rounded-lg">
                                        <div class="flex items-center justify-between">
                                            <div class="flex items-center gap-3">
                                                <i class="pi pi-file text-green-600"></i>
                                                <span class="text-green-800 font-medium" i18n>File uploaded successfully</span>
                                            </div>
                                            <p-button appGlobalLoadingDisable type="button" icon="pi pi-times" severity="secondary" size="small"
                                                (onClick)="removeUploadedFile()" styleClass="p-button-text"></p-button>
                                        </div>

                                        <!-- Show thumbnail only for image files -->
                                        <div *ngIf="uploadedFile && isImageFile(uploadedFile)" class="mt-4">
                                            <h5 class="text-sm font-medium text-gray-700 mb-2" i18n>Preview</h5>
                                            <div class="flex justify-center">
                                                <img [src]="uploadedFileUrl" alt="File preview" i18n-alt
                                                    class="max-w-full h-auto max-h-48 object-contain border rounded-lg shadow-sm" />
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Hidden documents field -->
                                    <input type="hidden" formControlName="documents" />

                                    <!-- Main File Upload with Drag & Drop -->
                                    <div class="mb-4 p-4 border-2 border-dashed rounded-lg text-center drag-drop-area"
                                        [class]="dragOver ? 'border-blue-500 bg-blue-50 drag-over' : 'border-gray-300'"
                                        [class.loading]="isFileUploading" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
                                        (drop)="onDrop($event)">

                                        <input type="file" accept="application/pdf,image/png,image/jpeg,image/jpg"
                                            (change)="onFileUpload($event)" class="hidden" [disabled]="isFileUploading" id="file-input-schedule" />

                                        <div class="flex flex-col items-center justify-center py-4">
                                            <svg class="mb-2" width="38" height="27" viewBox="0 0 38 27" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M8.6875 26.875C4.0293 26.875 0.25 23.0957 0.25 18.4375C0.25 14.7578 2.60547 11.6289 5.88672 10.4746C5.88086 10.3164 5.875 10.1582 5.875 10C5.875 4.82031 10.0703 0.625 15.25 0.625C18.7246 0.625 21.7539 2.51172 23.377 5.32422C24.2676 4.72656 25.3457 4.375 26.5 4.375C29.6055 4.375 32.125 6.89453 32.125 10C32.125 10.7148 31.9902 11.3945 31.75 12.0273C35.1719 12.7188 37.75 15.748 37.75 19.375C37.75 23.5176 34.3926 26.875 30.25 26.875H8.6875ZM13.3164 14.1602C12.7656 14.7109 12.7656 15.6016 13.3164 16.1465C13.8672 16.6914 14.7578 16.6973 15.3027 16.1465L17.5879 13.8613V21.7188C17.5879 22.498 18.2148 23.125 18.9941 23.125C19.7734 23.125 20.4004 22.498 20.4004 21.7188V13.8613L22.6855 16.1465C23.2363 16.6973 24.127 16.6973 24.6719 16.1465C25.2168 15.5957 25.2227 14.7051 24.6719 14.1602L19.9844 9.47266C19.4336 8.92188 18.543 8.92188 17.998 9.47266L13.3105 14.1602H13.3164Z"
                                                    fill="#9CA3AF" />
                                            </svg>
                                            <label for="file-input-schedule" class="cursor-pointer text-blue-600 hover:text-blue-800 font-medium"
                                                [class.opacity-50]="isFileUploading" [class.cursor-not-allowed]="isFileUploading" i18n>
                                                {{ isFileUploading ? 'Uploading...' : 'Click to upload or drag and drop' }}
                                            </label>
                                            <p class="text-sm text-gray-500 mt-2" i18n>
                                                PDF, PNG, JPG (MAX. 10MB)
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Reservation Status -->
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div class="flex flex-col gap-2">
                                <label for="reservationStatus" class="font-medium text-gray-800 mb-1" i18n>
                                    Reservation Status <span *ngIf="isReservationStatusRequired" class="text-red-500">*</span>
                                </label>
                                <p-select id="reservationStatus" formControlName="reservationStatus" [options]="reservationStatusOptions"
                                    optionLabel="label" optionValue="value" 
                                    [placeholder]="isReservationStatusRequired ? 'Select reservation status (required)' : 'Select reservation status'"
                                    i18n-placeholder
                                    [class]="'w-full rounded-lg border text-base transition-all duration-200 focus:border-indigo-400 focus:ring-4 focus:ring-indigo-100 ' + 
                                    (sheduleInteractionForm.get('reservationStatus')?.invalid && sheduleInteractionForm.get('reservationStatus')?.touched ? 'border-red-500 focus:ring-red-100' : 'border-gray-300')">
                                </p-select>
                                
                                <!-- Validation Error -->
                                <div *ngIf="sheduleInteractionForm.get('reservationStatus')?.invalid && sheduleInteractionForm.get('reservationStatus')?.touched" 
                                     class="mt-1 text-sm text-red-600" i18n>
                                    Reservation status is required when interaction is completed.
                                </div>
                                
                                <!-- Status Description -->
                                <div *ngIf="getReservationStatusDescription()" class="mt-2 p-2 bg-blue-50 border border-blue-200 rounded-md">
                                    <p class="text-sm text-blue-800">
                                        <i class="pi pi-info-circle mr-1"></i>
                                        {{ getReservationStatusDescription() }}
                                    </p>
                                </div>

                                <!-- Additional Info Cards -->
                                <div *ngIf="sheduleInteractionForm.get('reservationStatus')?.value === 'Not Interested'" class="mt-3">
                                    <div class="p-4 bg-red-50 border border-red-200 rounded-lg">
                                        <div class="flex items-start">
                                            <div class="flex-shrink-0">
                                                <i class="pi pi-exclamation-triangle text-red-600 text-lg"></i>
                                            </div>
                                            <div class="ml-3">
                                                <h3 class="text-sm font-medium text-red-800 mb-1" i18n>
                                                    Reservation Closure Notice
                                                </h3>
                                                <p class="text-sm text-red-700" i18n>
                                                    This reservation will be considered closed and moved to inactive status. 
                                                    The customer will no longer receive follow-up communications.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="sheduleInteractionForm.get('reservationStatus')?.value === 'Converted'" class="mt-3">
                                    <div class="p-4 bg-green-50 border border-green-200 rounded-lg">
                                        <div class="flex items-start">
                                            <div class="flex-shrink-0">
                                                <i class="pi pi-check-circle text-green-600 text-lg"></i>
                                            </div>
                                            <div class="ml-3">
                                                <h3 class="text-sm font-medium text-green-800 mb-1" i18n>
                                                    Conversion Success
                                                </h3>
                                                <p class="text-sm text-green-700" i18n>
                                                    Congratulations! The customer has converted. You will be redirected to create a contract 
                                                    to formalize the business relationship.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="sheduleInteractionForm.get('reservationStatus')?.value === 'Interested'" class="mt-3">
                                    <div class="p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
                                        <div class="flex items-start">
                                            <div class="flex-shrink-0">
                                                <i class="pi pi-clock text-yellow-600 text-lg"></i>
                                            </div>
                                            <div class="ml-3">
                                                <h3 class="text-sm font-medium text-yellow-800 mb-1" i18n>
                                                    Follow-up Required
                                                </h3>
                                                <p class="text-sm text-yellow-700" i18n>
                                                    The customer is interested and requires follow-up. You can either schedule a follow-up 
                                                    interaction now or save this interaction and schedule later.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Action Buttons -->
                <div class="flex flex-col sm:flex-row justify-start pt-6 gap-3">
                    <p-button type="button" 
                              label="Save" i18n-label
                              styleClass="p-button-primary w-full sm:w-auto"
                              icon="pi pi-save" 
                              (onClick)="onSubmit()" 
                              [loading]="isMainButtonLoading">
                    </p-button>
                    
                    <!-- Cancel button -->
                    <p-button type="button" 
                              label="Cancel" i18n-label
                              styleClass="p-button-outlined p-button-secondary w-full sm:w-auto"
                              (onClick)="onCancel()"
                              [disabled]="isMainButtonLoading">
                    </p-button>
                </div>
            </p-card>
        </form>
    </div>

    <!-- Form Submission Loading Overlay -->
    <div *ngIf="isMainButtonLoading" class="fixed inset-0 bg-white bg-opacity-90 flex items-center justify-center z-50">
        <app-loading-spinner size="large" type="full-screen" i18n-message message="Processing interaction..."></app-loading-spinner>
    </div>
</div>